import Icon, { IconNames as _IconNames } from './Icon';

export type IconNames = _IconNames;
export default Icon;
